import { render } from "./HospitalAccountManagers.vue?vue&type=template&id=935a6e94"
import script from "./HospitalAccountManagers.vue?vue&type=script&lang=js"
export * from "./HospitalAccountManagers.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/labAccountManagers/HospitalAccountManagers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "935a6e94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('935a6e94', __exports__)) {
    console.log('reload')
    api.reload('935a6e94', __exports__)
  }
  
  module.hot.accept("./HospitalAccountManagers.vue?vue&type=template&id=935a6e94", () => {
    console.log('re-render')
    api.rerender('935a6e94', render)
  })

}


export default __exports__